<template>
  <div id="home" class="main">
    <!-- 头部 -->
    <Header index="1"></Header>
    <div class="content">
      <!--[if lte IE 9]>
        <p class="browserupgrade">
          You are using an <strong>outdated</strong> browser. Please <a
          href="https://browsehappy.com/">upgrade your browser</a> to improve
          your experience and security.
        </p>
      <![endif]-->

      <!-- Add your site or application content here -->

      <!-- prealoder area start -->
      <!-- <div id="loading">
            <div id="loading-center">
                <div id="loading-center-absolute">
                <div class="object" id="first_object"></div>
                <div class="object" id="second_object"></div>
                <div class="object" id="third_object"></div>
                </div>
            </div>      
        </div> -->
      <!-- prealoder area end -->
      <!-- page title area start -->
      <!-- <ChartLine   ref="chart_line_one" style="width: 600px;height:400px;" /> -->
      <section
        class="page__title p-relative d-flex align-items-center"
        data-background="assets/img/page-title/page-title-1.jpg"
        :style="'background-image:url(' + allurl + bannerimg + ')'"
      >
        <div class="container">
          <div class="row">
            <div class="col-xl-12">
              <div class="page__title-inner text-center">
                <h1>About Us</h1>
                <div class="page__title-breadcrumb">
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb justify-content-center">
                      <li class="breadcrumb-item">
                        <a @click="goindex">Home</a>
                      </li>
                      <li class="breadcrumb-item active" aria-current="page">
                        about us
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        class=" p-relative d-flex align-items-center"
      >
        <div class="container">
          <div class="row">
            <div class="col-xl-12">
              <div v-html="aboutContent" class="padding"></div>
            </div>
          </div>
        </div>
      </section>
      <Footer></Footer>
    </div>
  </div>
</template>

                                                                                                           
<script type="text/javascript">
// $('.header .right_icon .icon_msg').on('click',function(){
//   consol.log(123124)
//         $('.mask,.pop_service').fadeIn();
//         $('.pop_service .close,.mask').on('click',function(){
//             $('.mask,.pop_service').fadeOut();
//         })
//     });
/*var p3Swiper = new Swiper('.part3 .swiper-container', {
        autoplay: true,//可选选项，自动滑动
        effect : 'slide',
        pagination: {
            el: '.part3 .swiper-pagination',
            clickable :true,
        }
    })*/
</script>


<script>
// import ChartLine  from '../../components/echart.vue'
import Footer from "../../components/footer.vue";
import Header from "../../components/header.vue";
//局部注册   百度地图
import BaiduMap from "../../components/map.vue";
import { getabout, getgoodstype } from "@/api/index/index";
export default {
  components: { Header, Footer, BaiduMap,  },
  name: "home",
  data() {
    return {
       name:'销量',
          xData: ['衬衫', '羊毛衫', '雪纺衫', '裤子', '高跟鞋', '袜子'],
          yData:[
        { value: 1048, name: 'Search Engine' },
        { value: 735, name: 'Direct' },
        { value: 580, name: 'Email' },
        { value: 484, name: 'Union Ads' },
        { value: 300, name: 'Video Ads' }
      ],
      drawer: false, //1
      // direction: 'rtl',//1导航抽屉
      currentIndex: "",
      teacherIndex: "",
      bannerimg: "",

      ishove: true,
      activeBtn: 2,
      imgurl: "https://admin.cdhyxyl.com/",
      clickIndex: 0,
      aboutContent: '',

      leftIcon: require("../../assets/left.png"),
      rightIcon: require("../../assets/right-active.png"),
    };
  },
  mounted() {
    // const {name,xData,yData} = this
      //  console.log(this.$refs)
      //  this.$refs.chart_line_one.initChart(name,xData,yData)
    this.getinfo();
    // let video = document.getElementsByClassName("video");
    // video.play();
  },
  methods: {
    
    getinfo() {
      getabout().then((res) => {
        this.bannerimg=res.banner[0].image
        this.aboutContent = res.content.content;
        console.log(res, "resss");
      });
      getgoodstype().then((res) => {
        // this.bannerimg = res.banner[0].image;
      });
    },
    opendr() {
      console.log(1112);
    },
    closeDrawer() {
      console.log(1);
    },
    handleClose(done) {
      console.log(123123);
      done();
    },
    changestyle(index) {
      this.currentIndex = index;
    },
    originstyle() {
      this.currentIndex = "";
    },
    clicktap(index) {
      this.clickIndex = index;
    },
    goindex(){
      this.$router.push({ name: "home" });
    },
    arrowClick(val) {
      if (val === "right") {
        this.$refs.cardShow.next();
        console.log(val);
        this.activeBtn = 2;
        this.rightIcon = require("../../assets/right-active.png");
        this.leftIcon = require("../../assets/left.png");
      } else {
        this.$refs.cardShow.prev();
        console.log(val);
        this.activeBtn = 1;
        this.leftIcon = require("../../assets/left-active.png");
        this.rightIcon = require("../../assets/right.png");
      }
    },
    changehandle(currentIndex, originIndex) {
      console.log(currentIndex, originIndex);
    },
    // 移入事件
    delHandleMouseEnter(index) {
      this.teacherIndex = index;
    },
    // 移出
    delHandleMouseleave() {
      this.teacherIndex = "";
    },
  },
};
</script>
<style>
.aboutcontent img {
  width: 100% !important;
}
/* .part img{width: 100%!important;} */
</style>
<style scoped lang='less'>
/*!
*/

.wrapper.ksdq .tit {
  margin: 8% 0 3%;
  font-size: 50px;
  line-height: 1em;
  color: #000;
  text-align: center;
}

.wrapper.ksdq .con_wrap dl {
  border-bottom: 1px solid #cccccc;
  padding: 45px 0 25px;
}
.wrapper.ksdq .con_wrap dl dt {
  font-size: 22px;
  line-height: 1.5em;
  color: #000;
  margin-bottom: 25px;
}
.wrapper.ksdq .con_wrap dl dd a {
  font-size: 18px;
  line-height: 1.5em;
  white-space: nowrap;
  color: #666666;
  margin-right: 55px;
}
.wrapper.ksdq .con_wrap dl dd a:hover {
  color: #000;
}
.wrapper.ksdq .btn_wrap {
  margin-top: 6%;
}

@media screen and (min-width: 1200px) {
  .wrapper.ksdq .bg1200 {
    width: 1200px;
    margin: 0 auto;
  }
}
.padding{padding:10px;padding-top:30px}
</style>




// WEBPACK FOOTER //
// src/views/about/about.vue